import { Dimensions, StyleSheet } from 'react-native'

import colors from '../../Themes/Colors'

const styles = StyleSheet.create({
  wraper: {
    height: 200,
    justifyContent: 'space-between',
    paddingBottom: 12,
    paddingTop: 8,
    paddingHorizontal: Dimensions.get('window').width > 700 && '10%'
  },
  container: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    flexDirection: 'row',
    padding: 16
  },
  titleStyle: {
    textAlign: 'center',
    flexWrap: 'wrap',
    color: colors.white
  },
  touchables: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  leftBlock: {
    justifyContent: 'flex-start'
  },
  rightBlock: {
    justifyContent: 'flex-end'
  },
  icon: {
    width: 28,
    height: 28,
    resizeMode: 'contain',
    tintColor: colors.white
  },
  imageBackground: {
    width: '100%'
  }
})

export default styles
